export const getBackgroundClass = (background) => {
  const bgClassMap = {
    default: "bg-white",
    light: "bg-light",
    dark: "bg-dark",
    primary: "bg-primary-color",
  };

  return bgClassMap[background] || "";
};

export const getLayoutClass = (layout) => {
  return layout === "reverse" ? "flex-row-reverse" : "";
};

export const getSectionLayoutType = (settings) => {
  return settings?.sectionLayoutType || "";
};


export const getIconClass = (title) => {
  if (!title) return "flaticon-bitcoin";

  const lowerTitle = title.toLowerCase();

  if (lowerTitle.includes("fintech")) return "flaticon-bitcoin";
  if (lowerTitle.includes("retail")) return "flaticon-order";
  if (lowerTitle.includes("manufacturing")) return "flaticon-factory";
  if (lowerTitle.includes("health")) return "flaticon-hospital";
  if (lowerTitle.includes("education")) return "flaticon-distance-education";
  if (lowerTitle.includes("logistics")) return "flaticon-tracking";

  return "flaticon-bitcoin"; // fallback
};
